import { useState, useCallback } from 'react';

interface UseDisclaimerReturn {
    isOpen: boolean;
    openDisclaimer: () => void;
    closeDisclaimer: () => void;
}

export const useDisclaimer = (): UseDisclaimerReturn => {
    const [isOpen, setIsOpen] = useState(false);

    const openDisclaimer = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeDisclaimer = useCallback(() => {
        setIsOpen(false);
    }, []);

    return {
        isOpen,
        openDisclaimer,
        closeDisclaimer
    };
};

export default useDisclaimer;